import React from 'react'
import './Main.css'
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import ProductosMain from '../../Components/Admin/ProductosMain/ProductosMain'
import UsuariosMain from '../../Components/Admin/UsuariosMain/UsuariosMain'
import CardsCantidad from '../../Components/Admin/CardsCantidad/CardsCantidad'
import PedidosEntregadosChart from '../../Components/Admin/PedidosEntregadosChart/PedidosEntregadosChart';
import PedidosPorEstado from '../../Components/Admin/PedidosEntregadosChart/PedidosPorEstado';
import DailyExpenseGraph from '../../Components/Admin/ExpenseGraph/DailyExpenseGraph'

export default function Main() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='containerMain'>
                    <div className='deFLexMain'>
                        <CardsCantidad />
                        <UsuariosMain />
                    </div>
                    <div className='deFLexMain'>
                        <ProductosMain />
                    </div>

                    {/* Contenedor para los gráficos alineados en fila */}
                    <div>
                        <DailyExpenseGraph />
                    </div>
                    <div className='chartsRow'>
                        <PedidosEntregadosChart />
                        <PedidosPorEstado />
                    </div>

                </div>
            </section>
        </div>
    )
}
